import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/slices/authSlice';
import teacherDataReducer from './redux/slices/teacherDataSlice';
import adminDataReducer from './redux/slices/adminDataSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    teacherData: teacherDataReducer,
    adminData: adminDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store; 